


















import { IGuest } from "@/@types/admin/guest/user";
import { Component, Prop, Vue } from "vue-property-decorator";
import { getDate } from "@/services/dateTime/getFullDate";

@Component({})
export default class ShortGuestCard extends Vue {
  @Prop({ type: Object, default: null }) guest!: IGuest;

  get arrival(): string {
    if (!this.guest.stay_data?.arrival) return "";
    return getDate(this.guest.stay_data.arrival);
  }
}
